import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { GitHubLinkedService } from 'app/model/linkedservice/github.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GitHubLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                username: '*',
                credential: 'secret'
            }
        }
    }
})
export class GitHubLinkedServiceAdapter extends LinkedServiceAdapter<GitHubLinkedService> {
    protected modelConstructor(): new () => GitHubLinkedService {
        return GitHubLinkedService;
    }

    protected model(): IModel {
        return GitHubLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: GitHubLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.GitHubLinkedService;

        properties.type = Metamodel.modelFor(GitHubLinkedService).name;
        properties.typeProperties = {
            username: linkedService.username,
            credential: passwordOrAKVtoSecretBase(linkedService.credential, this.context)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: GitHubLinkedService): Promise<GitHubLinkedService> {
        const properties = linkedServiceResource.properties as Model.GitHubLinkedService;
        linkedService.username = properties.typeProperties.username;
        linkedService.credential = secretBaseToPasswordOrAKV(properties.typeProperties.credential, true, this.context);
        return linkedService;
    }
}
